import React, { useEffect } from 'react';
import './styles.css';

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function setCookie(name, value) {
  document.cookie = `${name}=${value}; path=/`;
}

export default function ThirdCard() {
  const isLoggedIn = getCookie('COOKIE_LOGGED_IN') === 'true';

  useEffect(() => {
    if (!isLoggedIn) return;
    const username = 'admin';
    setCookie('USER_NAME', username);
    setCookie('USER_ROLE', 'administrator');
    setCookie('USER_ID', btoa(username));
    setCookie('USER_SESSION_TOKEN', btoa(`${username}:session`));
  }, [isLoggedIn]);

  if (!isLoggedIn) {
    return null;
  }

  return (
    <div className='third-card'>

      <img
        src={process.env.PUBLIC_URL + '/images/blob1.png'}
        alt="blob"
        className="blob3"
      />
      <div className='placeholder-box'>
        <p className='placeholder-label'>YOU ARE LOGGED IN</p>
      </div>
    </div>
  );
}
